import './Checkbox.scss';

import React from 'react';
import PropTypes from 'prop-types';

import FormValidationMessage from 'components/FormValidationMessage';
import Label from 'components/Label';

export default class Checkbox extends React.Component {
    static propTypes = {
        checked: PropTypes.bool.isRequired,
        disabled: PropTypes.bool,
        id: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string
        ]).isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        validation: PropTypes.object
    };

    _handleChange(event) {
        this.props.onChange(this.props.name, event.target.checked === true);
    }

    render() {
        let { validation } = this.props;
        return (
            <div className="o-checkbox">
                <input
                    checked={this.props.checked === true}
                    className={`c-checkbox ${this.props.className || ''}`}
                    disabled={this.props.disabled === true}
                    id={this.props.id}
                    name={this.props.name}
                    onChange={this.props.onChange.bind(this)}
                    title={this.props.label}
                    type="checkbox"
                />
                <Label htmlFor={this.props.id}>{this.props.label}</Label>

                {validation && validation.show && <FormValidationMessage>{validation.error.reason}</FormValidationMessage>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js